<template>
	<div>
		<div class="product-desc">
			<div class="header">
				Learn languages with Spotify.
			</div>
			<div class="subHeader">
				Connect with your Spotify account and have fun with the translated
				lyrics of your favorite songs.
			</div>
		</div>
	</div>
</template>

<script>
export default {};
</script>

<style scoped>
.product-desc {
	margin: 100px 0;
}
.header {
	font-size: 60px;
	color: var(--titleColor);
	font-weight: bold;
}
.subHeader {
	font-size: 18px;
	color: var(--textColor);
	font-weight: 400;
	letter-spacing: 0.2px;
	-webkit-font-smoothing: antialiased;
	margin: 40px 0;
}
.callContainer {
	width: 100%;
	display: flex;
	align-items: left;
}
@media only screen and (max-width: 750px) {
	.product-desc {
		margin: 0 16px;
	}
}
</style>
